import Logo from '../assets/logo.png';

const ErrorPage = props => {
    return <div className="errorContainer">
        <img src={Logo} alt='Logo' className='logo' />
        <h3>Произошла непредвиденная ошибка!</h3>
        <div className='button' onClick={() => window.location.reload()}>
			<span>Обновить страницу</span>
		</div>
        <pre style={{ color: "red" }}>{props.error.message}</pre>
    </div>
}

export default ErrorPage;